module.exports = __webpack_public_path__ + "static/media/border-inner.a4ae5502.svg";